import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import BackgroundImage from "/Images/Background.svg"; // Pastikan path benar
import "../Components/HeroTransition.css"; // Import the CSS file

const HeroSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: isMobile ? "0 2rem" : "0 6rem",
      paddingTop: isMobile ? "6rem" : "12rem",
      paddingBottom: isMobile ? "6rem" : "20rem",
      color: "#FFFFFF",
      textAlign: "center", // Pusatkan konten
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh", // Tinggi minimum untuk memenuhi viewport
    },
    heading: {
      fontSize: isMobile ? "32px" : "48px",
      fontWeight: 600, // Bold
      lineHeight: "1.2",
      marginBottom: isMobile ? "1.5rem" : "2.5rem",
      maxWidth: "800px",
      marginTop: "3rem",
    },
    highlight: {
      color: "#F4E37B", // Warna kuning seperti pada gambar
    },
    subheading: {
      fontSize: isMobile ? "16px" : "20px",
      color: "#E7E4E2",
      marginBottom: isMobile ? "2rem" : "0.5rem",
      maxWidth: "901px", // Batasi lebar teks agar proporsional
      lineHeight: "1.5",
      minHeight: "155px",
    },
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "14px" : "16px",
      cursor: "pointer",
     },
  };

  return (
    <section style={styles.container}>
      {/* Heading */}
      <h1 style={styles.heading}>
        Empowering Security <br />
        with <span style={styles.highlight}>Advanced Technology</span>
      </h1>

      {/* Subheading */}
      <p style={styles.subheading}>
        We leverage advanced technology to ensure the utmost security for your digital assets. Our industry-leading certifications validate our commitment to safeguarding your assets, providing trusted solutions for all your custody needs.
      </p>

      {/* Button */}
      <button style={styles.button}>Learn More</button>
    </section>
  );
};

export default HeroSection;
